import React from "react";
import styled from "styled-components";
import { visuallyHidden } from "./Styles";

const OffscreenDiv = styled.div`
  ${visuallyHidden}
`;

export default function OffScreen({ children }) {
  return <OffscreenDiv>{children}</OffscreenDiv>;
}
